module.exports = "<div class=\"image-slick\" ref=\"root\">\r\n    <div class=\"slick\" style=\"margin-bottom: 0;width: 100%;height: 100%;position: relative;overflow: hidden;\">\r\n        <img v-for=\"(item,index) in SlickImage\" :src=\"item\" style=\"width:100%;height: 100%;display: inline-block;\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./fnjinews/component/image-slick.html
// module id = 121
// module chunks = 0